import { render, staticRenderFns } from "./CancerCoachingSelectCoach.vue?vue&type=template&id=0b281570"
import script from "./CancerCoachingSelectCoach.vue?vue&type=script&lang=js"
export * from "./CancerCoachingSelectCoach.vue?vue&type=script&lang=js"
import style0 from "./CancerCoachingSelectCoach.vue?vue&type=style&index=0&id=0b281570&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports